import { SafeSupportChatMessage, SupportChat, UserAsset } from '@interfaces';

export type ChatState = Readonly<{
  messages: SafeSupportChatMessage[];
  chat: SupportChat;
  errorMessage: string | null;
  loading: boolean;
  loadingAttachments: boolean;
  messageAttachmentsToAdd: {
    // file.name -> name on the computer of uploader -> we will make sure that no duplicates are allowed
    [key: string]: {
      error: any;
      loading: boolean;
      uploaded: boolean;
      userAsset: UserAsset;
    };
  };
}>;

export const initialState: ChatState = {
  messages: null,
  chat: null,
  errorMessage: null,
  loading: false,
  loadingAttachments: false,
  messageAttachmentsToAdd: {},
};
